/* collapsable-jumplist:
 *
 * Make jumplist collapsable.
 *
 * Author: Niels Giesen
 * Copyright 2011, 2015 Berkeley Bridge
 *
 */
(function ($) {
  $(function () {
    $(document).on("bb:postHandleData", function (event, data) {
      if (data && data.jumplist) {
        // @todo: currently jumplist always has a selected item.
        // Just do not know when this happened exactly. So leave the
        // first statement in for now.
        //
        // First set .past:last
        // to .selected if no .selected.
        if (!$(".bb-jumplist").is(":has(.selected)"))
          $(".bb-jumplist .past:last").addClass("selected");
        $(".bb-jumplist li:has(.selected)").addClass("bb-hascurrent");
        $(".bb-jumplist li:has(ul)").addClass("bb-stale-collapsed");
        $(".bb-jumplist li:has(.selected):has(ul)")
          .removeClass("bb-stale-collapsed")
          .addClass("bb-stale-expanded");
      }
    });
  });
})(jQuery);
